import styled from "styled-components";
import { withStyles, TextField } from "@material-ui/core";

interface PasswordInputProps {
  value: string;
}
export const PasswordInput = withStyles(({
    root:{
      backgroundColor: '#fff',
      borderRadius: '24px !important',
      border: 'none',

    '& label + .MuiInput-formControl': {
      margin: '0',
      'padding-top': '16px',
    },
 
    '& .MuiInputBase-root.Mui-focused': {
      border: (props: PasswordInputProps) => props.value && '1px solid #3978D7',
      'border-radius': '24px',
    },

      '& .MuiFormLabel-root.Mui-error': {
        color: '#A30000',
        'font-size': '12px',
        'line-height': '15.6px',
      },

      '& .MuiInputLabel-root.Mui-focused': {
        'font-size': '12px',
      },

      '& .MuiFormLabel-root.MuiFormLabel-filled': {
        'font-size': '12px',
      },

      '& label':{
        color: '#343A40',
        'font-family': 'Gotham',
        'line-height': '16px',
        'font-size': '16px',
      },
      
      '& .MuiInputLabel-formControl':{
        top: '-9px',
        left: '24px',
        margin: 0,
      },

      '& .MuiInputBase-input': {
        padding: '6px 24px 7px;',
        color: '#343A40',
        'font-family': 'Gotham',
        'font-weight': 400,
        'line-height': '16px',
      },

      '& .MuiInputLabel-shrink' :{
        color: '#343A40',
        top: '7px !important',
        'font-weight': 325,
      },

      '& input:-internal-autofill-selected': {
        appearance: 'unset',
        '-webkit-box-shadow': '0 0 0 30px #fff inset !important',
        padding: 0,
        margin: '6px 24px 7px',
      },

      '& input:autofill' : {
        appearance: 'unset',
        '-webkit-box-shadow': '0 0 0 30px #fff inset !important',
        padding: 0,
        margin: '6px 24px 7px',
      }, 

      '& input:-webkit-autofill' : {
        appearance: 'unset',
        '-webkit-box-shadow': '0 0 0 30px #fff inset !important',
        padding: 0,
        margin: '6px 24px 7px',
      }, 
    }
}))(TextField);

export const ContainerPasswordStyled = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: 45px;
`;

export const ContainerEyeStyled = styled.div`
    cursor: pointer;
    position: absolute;
    right: 25px;
    font-size: 14px;
    font-weight: 450;
    line-height: 18.2px;
    color: #4A90E2;

`;